import React, { useEffect } from 'react';

type Props = {
  modal: {
    info: {
      message: string;
    };
  };
};

const IntercomModalPlaceholder: React.FC<Props> = (props) => {
  const { modal } = props;

  useEffect(() => {
    const launchIntercomInterval = setInterval(() => {
      if (window.Intercom) {
        window.Intercom('show');
        window.Intercom('showNewMessage', modal.info.message);
      }
      clearInterval(launchIntercomInterval);
    }, 10);
  }, []);

  return <span />;
};

IntercomModalPlaceholder.closeBtnFill = '#9d9d9d';

export default IntercomModalPlaceholder;
